// CC
import TargetDefinition from '../components/campaign-manager/cc/TargetDefinition.vue'
import ContentSelectionAndTag from '../components/campaign-manager/cc/ContentSelectionAndTag.vue'
import FinalCheckAndCampaignRelease from '../components/campaign-manager/cc/FinalCheckAndCampaignRelease.vue'
import CampaignSetup from '../components/campaign-manager/cc/CampaignSetup.vue'

// DDS - Parent
import DDSParentCampaignSetup from '../components/campaign-manager/dds/parent/CampaignSetup.vue'

// DDS - Child
import DDSChildCampaignSetup from '../components/campaign-manager/dds/child/CampaignSetup.vue'
import ContentSelection from '../components/campaign-manager/dds/child/ContentSelection.vue'

// Technical Campaign
import TechnicalCampaignSetup from '../components/campaign-manager/technical/CampaignSetup.vue'

// Sales Full
import SalesCampaignSetup from '../components/campaign-manager/sales/CampaignSetup.vue'
import SalesTargetDefinition from '../components/campaign-manager/sales/TargetDefinition.vue'
import SalesFinalCheckAndCampaignRelease from '../components/campaign-manager/sales/FinalCheckAndCampaignRelease.vue'

// Fast Counter
import PreviewSetup from '../components/fast-counter/PreviewSetup.vue'
import FCTargetDefinition from '../components/fast-counter/TargetDefinition.vue'
import FinalCheck from '../components/fast-counter/FinalCheck.vue'

export const fullCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: CampaignSetup
  },
  offers: {
    stepNumber: 1,
    label: 'sections.contentSelectionAndTag',
    component: ContentSelectionAndTag
  },
  filters: {
    stepNumber: 2,
    label: 'sections.targetDefinition',
    component: TargetDefinition
  },
  preview: {
    stepNumber: 3,
    label: 'sections.finalCheckAndCampaignRelease',
    component: FinalCheckAndCampaignRelease
  }
}

export const headerCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: CampaignSetup
  }
}

export const vhrCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: CampaignSetup
  }
}

export const salesCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: CampaignSetup
  }
}

export const salesFullCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: SalesCampaignSetup
  },
  filters: {
    stepNumber: 1,
    label: 'sections.targetDefinition',
    component: SalesTargetDefinition
  },
  preview: {
    stepNumber: 2,
    label: 'sections.finalCheckAndCampaignRelease',
    component: SalesFinalCheckAndCampaignRelease
  }
}

export const ddsParentCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: DDSParentCampaignSetup
  }
}

export const ddsChildCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: DDSChildCampaignSetup
  },
  contentSelection: {
    stepNumber: 1,
    label: 'sections.contentSelection',
    component: ContentSelection
  }
}

export const technicalCampaign = {
  campaignData: {
    stepNumber: 0,
    label: 'sections.campaignSetup',
    component: TechnicalCampaignSetup
  }
}

// Fast Counter
export const fastCounter = {
  previewData: {
    stepNumber: 0,
    label: 'sections.previewSetup',
    component: PreviewSetup
  },
  targetDefinition: {
    stepNumber: 1,
    label: 'sections.targetDefinition',
    component: FCTargetDefinition
  },
  preview: {
    stepNumber: 2,
    label: 'sections.preview',
    component: FinalCheck
  }
}
